import { render, staticRenderFns } from "./EditDotsVisitDate.vue?vue&type=template&id=0c9dc171&scoped=true"
import script from "./EditDotsVisitDate.vue?vue&type=script&lang=js"
export * from "./EditDotsVisitDate.vue?vue&type=script&lang=js"
import style0 from "./EditDotsVisitDate.vue?vue&type=style&index=0&id=0c9dc171&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9dc171",
  null
  
)

export default component.exports